import React, { useState } from 'react';
import { SearchApp } from '../../search/components/search-app';
import { SearchList } from '../../search/components/search-list';
import { CheckBoxFilter } from '../../search/components/check-box-filter';
import { All } from '../../search/search-model';
import { PageModel, ArticlePage, ViewType } from './models';
import { ArticleCardView } from './article-card-view';
import { ArticleListView } from './article-list-view';
import { ListViewSorts } from './list-view-sort';
import { TcsmModal } from '../../global/components/tcsm-modal';

export interface Props {
	pageModel: PageModel;
}

const allOptions = {
	filterKey: 'category',
	filterValue: All,
	filterDisplayValue: All,
};


function TopicPageSearch(props: Props) {

	const { pageModel } = props;
	const [view, setView] = useState(ViewType.card);
	const [videoLink, setVideoLink] = useState(null);
	const categories = pageModel?.articlePages?.map(article => article?.category).filter(a => a);
	const uniqueArray = Array.from(new Set(categories))
	const filterOptions = [allOptions].concat(uniqueArray?.map(item => {
		return {
			filterKey: 'category',
			filterValue: item,
			filterDisplayValue: item,
		}
	}));

	return (
		<div >
			<SearchApp initialList={pageModel?.articlePages} appName='topic-page-search'>
				
				{
					pageModel.cardViewOnly === 'False' &&
					<>
						<CheckBoxFilter
							name='category'
							options={filterOptions}
							label={pageModel?.filterBy}
							clearText={pageModel.clearFilterText}
							setView={setView}
							view={view}
						/>

						{
							view === ViewType.list &&
							<ListViewSorts pageModel={pageModel} />
						}
					</>

				}

				{
					view === ViewType.card ?
						<div className='topic-grid'>
							<SearchList
								showAll
								renderList={
									(item: ArticlePage) =>
										<ArticleCardView article={item} setVideo={setVideoLink} showDatesAndCategory={pageModel.hideDatesAndCategories !== 'True'} />

								}
							/>
						</div> :
						<div className='list-container'>
							<SearchList
								showAll
								renderList={
									(item: ArticlePage) =>
										<ArticleListView article={item} setVideo={setVideoLink} showDatesAndCategory={pageModel.hideDatesAndCategories !== 'True'} />
								}
							/>
						</div>
				}
			</SearchApp>
			<TcsmModal
				open={!!videoLink}
				handleClose={() => setVideoLink(null)}
			>
				<iframe width='640' height='360' src={videoLink} frameBorder='0' allowFullScreen ></iframe>
			</TcsmModal>
		</div>
	);
}

export default TopicPageSearch;